// <template>
// </template>
// <script>
  import ChartMaker from './factory/gbasechart'
  import AnyChart from './factory/anychart'
  import HighChart from './factory/highchart'
  import EChart from './factory/echart'
  import anychart from 'anychart'
  import jQuery from 'jquery'
  window.$ = window.jQuery = jQuery
  export default {
        name : 'Home',

        props:{
        	branch:{
        	 type:String,
        	 default:"AnyChart"
        	},
          genre:{
             type:String,
              default:"column"
          },
          container:{
            type:String,
            default:"container0"
          },
          dataInit:{
            type:Array,
            default:function(){
              return []
            }
          }
        },
    created: function() {
      this.drawChart();
    },


    methods: {

      drawChart:function(){

        var state =   {"chartInfo":{
                        "chart":
                          {
                          "genre":this.genre.split("_")[0]
                          },
                          "subChart":{
                            "genre":this.genre.split("_")
                          },
                          "data":this.dataInit
                        },
                        "container":this.container
                    };
        var chart = ChartMaker.factory(this.branch);
        chart.draw(state);
      },
    }
  }


// </script>



// WEBPACK FOOTER //
// ./src/Home.vue